import { useState } from 'react';
import { Routes, Route, useParams, Navigate } from 'react-router-dom';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { Dashboard } from '../Dashboard';
import { InvoiceList } from '../InvoiceList';
import { InvoiceForm } from '../InvoiceForm';
import { InvoiceTemplate } from '../invoices/InvoiceTemplate';
import { ClientList } from '../ClientList';
import { AnalyticsDashboard } from '../dashboard/RealAnalytics';
import { Settings } from '../settings/Settings';
import { TeamChat } from '../chat/TeamChat';
import { WorkspacesPage } from '../../pages/WorkspacesPage';
import { useApp } from '../../contexts/AppContext';
import { Invoice } from '../../types';

function InvoiceView() {
  const { id } = useParams();
  const { invoices } = useApp();
  const invoice = invoices.find(inv => inv.id === id);

  if (!invoice) {
    return (
      <div className="p-6">
        <div className="text-center py-12">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Invoice not found</h3>
          <p className="text-gray-500">The invoice you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }

  return <InvoiceTemplate invoice={invoice} showActions={true} />;
}

function InvoiceEdit() {
  const { id } = useParams();
  const { invoices } = useApp();
  const invoice = invoices.find(inv => inv.id === id);

  return (
    <InvoiceForm
      invoice={invoice}
      onSave={() => {}}
      onCancel={() => {}}
    />
  );
}

export function MainLayout() {
  const [isEditing, setIsEditing] = useState(false);
  const [currentInvoice, setCurrentInvoice] = useState<Invoice | null>(null);

  const handleSaveInvoice = () => {
    setIsEditing(false);
    setCurrentInvoice(null);
  };

  const handleCancelInvoice = () => {
    setIsEditing(false);
    setCurrentInvoice(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1">
          <Routes>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="invoices" element={<InvoiceList />} />
            <Route path="invoices/new" element={
              <InvoiceForm
                invoice={isEditing ? currentInvoice : null}
                onSave={handleSaveInvoice}
                onCancel={handleCancelInvoice}
              />
            } />
            <Route path="invoices/:id" element={<InvoiceView />} />
            <Route path="invoices/:id/edit" element={<InvoiceEdit />} />
            <Route path="clients" element={<ClientList />} />
            <Route path="analytics" element={<AnalyticsDashboard />} />
            <Route path="chat" element={<TeamChat />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/workspaces" element={<WorkspacesPage />} />
            <Route path="*" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}